import useMemberDashboardAccess from '../../common/Hooks/useMemberDashboardAccess';
import React, { ReactElement, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { UserType } from "../../../graphql/types";
import { UserTypeContext } from "../../../UserTypeContext";
import { RedirectUri, useEnumStrings } from "../../enumStrings";

// User can only access this if logged in so no need to check if logged in here
const Root = (): ReactElement => {
  const history = useHistory();
  const enumStrings = useEnumStrings();
  const { access, error } = useMemberDashboardAccess();

  const {
    state: { userType },
  } = useContext(UserTypeContext);

  useEffect(() => {
    if (userType === UserType.ChamberMemberAdmin) {
      if (!access) return;
      history.replace(access.cmpEnabled && !access.canManageProfile && access.canViewInvoices
        ? RedirectUri.memberInvoices : RedirectUri.manageCompanyProfileChamberMemberAdmin);
    } else if (userType === UserType.ChamberAdmin) {
      history.push(RedirectUri.chamberAdmin);
    } else if (userType === UserType.RootAdmin) {
      history.push(RedirectUri.rootAdmin);
    } else if (userType === UserType.PerkPartnerDiscountAdmin) {
      history.push(RedirectUri.editperkPartnerDiscountPageChamberAdmin);
    } else {
      history.push(RedirectUri.login);
    }
  }, [userType, history, access]);

  return <div>{error ? "Account access is unavailable. Please sign in again." : enumStrings.pleaseWait}</div>;
};

export default Root;
